import TinyStore from 'lib/tinyStore';
import { TReviewItem } from 'pages/dashboard/KlarityReviewsDashboradPage/types';
import { EAiResultType } from 'components/ReviewDisputeModals/AiResultModal';

type ReviewDisputeModal = {
    currentReview?: TReviewItem;
    showViewModal?: boolean;
    showEditModal?: boolean;
    showAiResultModal?: boolean;
    aiResultType?: EAiResultType | null;
    selectedReasonText?: string;
    isPracticeView?: boolean;
};

const Store = TinyStore.createStore<ReviewDisputeModal>({
    nameSpace: 'klarity',
    key: 'reviewDispute',
    crossBundle: false,
    runTime: true,
    initValue: {
        currentReview: undefined,
        showViewModal: false,
        showEditModal: false,
        showAiResultModal: false,
        aiResultType: null,
        selectedReasonText: '',
        isPracticeView: false,
    },
});
export default Store;
